import { ContratoCotacao } from "@/types/Contrato";
import {
  ContractStatus,
  statusIcon,
  statusText,
  statusVariant,
} from "@/utils/status-transport";
import { Separator } from "@radix-ui/react-separator";
import { ArrowRight } from "lucide-react";
import { Badge } from "../../../ui/badge";

export interface ContractsCardProps {
  contrato: ContratoCotacao;
  onViewMore: () => void;
  separator?: boolean;
}

export default function ContractsCard({
  contrato,
  onViewMore,
  separator = true,
}: ContractsCardProps) {
  return (
    <div className="space-y-2">
      <span className="font-semibold text-n-text-primary text-sm">
        Contrato nº&nbsp;{contrato.ctc_codigo}
      </span>
      <div className="flex gap-4 justify-between">
        <div className="flex flex-col md:flex-row w-[85%] justify-between text-sm gap-4">
          <div className="flex flex-col gap-1 md:col-span-1">
            <span className="font-semibold text-n-text-primary">De:</span>
            <span className="text-n-text-neutral">
              {contrato.mun_descricao_origem}
            </span>
          </div>
          <div className="flex flex-col gap-1 md:col-span-1">
            <span className="font-semibold text-n-text-primary">Para:</span>
            <span className="text-n-text-neutral">
              {contrato.mun_descricao_destino}
            </span>
          </div>
          <div className="flex flex-col gap-1 md:col-span-1">
            <span className="font-semibold text-n-text-primary">Veículo:</span>
            <span className="text-n-text-neutral">
              {contrato.vmd_descricao}
            </span>
          </div>
          <div className="flex flex-col gap-1 md:col-span-1">
            <span className="font-semibold text-n-text-primary">Status:</span>
            <Badge
              className="text-sm font-normal rounded-full gap-2"
              variant={`${
                statusVariant[contrato.status_situacao as ContractStatus]
              }`}
            >
              {statusText[contrato.status_situacao as ContractStatus]}
              {statusIcon[contrato.status_situacao as ContractStatus]}
            </Badge>
          </div>
        </div>
        <div className="flex justify-end items-start md:w-[15%] min-w-20">
          <button
            type="button"
            onClick={onViewMore}
            className="text-xs font-semibold text-n-green hover:underline flex items-center gap-1 "
          >
            Ver mais
            <ArrowRight size={14} />
          </button>
        </div>
      </div>
      {separator && <Separator />}
    </div>
  );
}
